module.exports = __webpack_public_path__ + "img/detail-phone.a0ad9773.svg";